export const InputForm = ({
  label,
  sublabel,
  type,
  placeholder,
  validation,
  submit,
  name,
  value,
  onInputChange,
}) => {
  return (
    <>
      <label className="form-label mb-0">
        {label}{" "}
        <span className="text-danger" style={{ fontSize: "10px" }}>
          {sublabel}
        </span>
      </label>
      <input
        type={type}
        className={`form-control ${validation && submit && "border-danger"}`}
        placeholder={placeholder}
        name={name}
        value={value}
        onChange={onInputChange}
      />
      {validation && submit && (
        <span className="text-danger">{validation}</span>
      )}
    </>
  );
};
